<template>
  <div class="company-page">
    <!-- Hero / Banner Section -->
    <div class="page-hero">
      <div class="hero-bg"></div>
      <div class="hero-content">
        <h1 class="hero-title">{{ $t('company.aboutUs') }}</h1>
        <p class="hero-subtitle">{{ $t('company.subtitle') }}</p>
      </div>
    </div>

    <!-- Mission & Vision Cards Section -->
    <div class="mission-vision-section">
      <div class="container">
        <!-- 可以在后续把 introText 融合在这里 -->
        <h2 class="section-title">{{ $t('company.whoWeAre') }}</h2>
        <p class="section-desc">{{ $t('company.introText') }}</p>

        <div class="mv-grid">
             <div class="mv-card">
            <div class="card-icon"><i class="el-icon-view"></i></div>
            <h3>{{ $t('company.visionTitle') }}</h3>
            <p>{{ $t('company.visionDesc') }}</p>
          </div>
          <div class="mv-card">
            <div class="card-icon"><i class="el-icon-aim"></i></div>
            <h3>{{ $t('company.missionTitle') }}</h3>
            <p>{{ $t('company.missionDesc') }}</p>
          </div>
       
        </div>
      </div>
    </div>

    <!-- Gallery / Culture Section (5 Image Placeholders) -->
    <!-- <div class="gallery-section">
      <div class="container">
        <h2 class="section-title">{{ $t('company.galleryTitle') }}</h2>
        <p class="section-desc">{{ $t('company.galleryDesc') }}</p>

        <!-- Bento Box Style Grid for 5 Images -->
        <!-- <div class="gallery-bento">
          <div class="gallery-item item-1">
            <img src="./../assets/img/company/1.png" alt="Gallery 1" class="placeholder-img" />
          </div>
          <div class="gallery-item item-2">
            <img src="./../assets/img/company/2.png" alt="Gallery 2" class="placeholder-img" />
          </div>
          <div class="gallery-item item-3">
            <img src="./../assets/img/company/3.png" alt="Gallery 3" class="placeholder-img" />
          </div>
          <div class="gallery-item item-4">
            <img src="./../assets/img/company/4.png" alt="Gallery 4" class="placeholder-img" />
          </div>
          <div class="gallery-item item-5">
            <img src="./../assets/img/company/5.png" alt="Gallery 5" class="placeholder-img" />
          </div>
        </div>
      </div>
    </div>  -->

    <!-- Modern Timeline History Section -->
    <div class="history-section">
      <div class="container">
        <h2 class="section-title">{{ $t('company.ourHistory') }}</h2>
        
        <div class="modern-timeline">
          <div class="timeline-line"></div>
          
          <div 
            class="timeline-node" 
            v-for="(item, index) in historyData" 
            :key="index"
            :class="[index % 2 === 0 ? 'node-left' : 'node-right']"
          >
            <!-- 时间胶囊标签 (仅保留给时间) -->
            <div class="time-badge">
              <span>{{ item.time }}</span>
            </div>

            <!-- 中心脉冲节点 -->
            <div class="pulse-dot">
              <div class="inner-dot"></div>
            </div>
            
            <!-- 内容信息卡片 -->
            <div class="node-content">
              <p class="event-desc">{{ $t(`company.history.events.${index}`) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Join Us Call to Action -->
    <div class="join-us-section">
      <div class="join-us-content">
        <h2>{{ $t('company.joinUsTitle') }}</h2>
        <p>{{ $t('company.joinUsDesc') }}</p>
        <button class="join-btn" @click="goToJobs">{{ $t('company.exploreJobs') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Company',
  data() {
    const baseHistory = [
      { time: '2023 Q2', key: 'e0' },
      { time: '2023 Q2', key: 'e1' },
      { time: '2024 Q2', key: 'e2' },
      { time: '2024 Q4', key: 'e3' },
      { time: '2025 Q2', key: 'e4' },
      { time: '2025 Q4', key: 'e5' },
      { time: '2026 Q1', key: 'e6' },
      { time: '2026 Q2', key: 'e7' }
    ]
    const mtExtra = (this.$brand && this.$brand.id === 'mt')
      ? [
          { time: '2026 Q3', key: 'e8' },
          { time: '2026 Q4', key: 'e9' }
        ]
      : []
    // Future 永远排在时间线最后
    const future = [{ time: 'Future', key: 'e10' }]
    return {
      historyData: [...baseHistory, ...mtExtra, ...future]
    }
  },
  methods: {
    goToJobs() {
      this.$router.push('/jobs');
    }
  }
}
</script>

<style lang="scss" scoped>
.company-page {
  min-height: 100vh;
  background: #f8fafc;
  padding-bottom: 80px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: #1e293b;
  text-align: center;
  margin: 0 0 16px;
}

.section-desc {
  font-size: 16px;
  color: #64748b;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 50px;
  line-height: 1.6;
}

/* ==================================================
   1. Hero Banner
   ================================================== */
.page-hero {
  position: relative;
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding-top: 70px; // account for navbar
  overflow: hidden;

  .hero-bg {
    position: absolute;
    inset: 0;
    // You can replace this gradient with an actual company cover image:
    // background: url('@/assets/img/company-cover.jpg') center/cover;
    background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
    
    // Pattern overlay for tech feel
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background-image: radial-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px);
      background-size: 30px 30px;
    }
  }

  .hero-content {
    position: relative;
    z-index: 2;
    max-width: 800px;
    padding: 0 20px;
    animation: fadeInUp 0.8s ease-out;

    .hero-title {
      font-size: 52px;
      font-weight: 800;
      margin-bottom: 20px;
      letter-spacing: -1px;
      text-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
    .hero-subtitle {
      font-size: 20px;
      opacity: 0.95;
      line-height: 1.6;
      text-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  }
}

/* ==================================================
   2. Mission & Vision Cards
   ================================================== */
.mission-vision-section {
  padding: 80px 0 40px;
  background: #fff;
}

.mv-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  max-width: 900px;
  margin: 0 auto;

  .mv-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    padding: 40px 30px;
    text-align: center;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 10px 30px rgba(0,0,0,0.03);

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(10, 127, 215, 0.1);
      border-color: #0a7fd7;
    }

    .card-icon {
      width: 70px;
      height: 70px;
      margin: 0 auto 24px;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;

      i {
        font-size: 32px;
        // color: #0ea5e9;
      }
    }

    h3 {
      font-size: 24px;
      font-weight: 700;
      color: #1e293b;
      margin-bottom: 16px;
    }

    p {
      color: #64748b;
      line-height: 1.6;
      font-size: 15px;
    }
  }
}

/* ==================================================
   3. Gallery / 5 Images Bento Grid
   ================================================== */
.gallery-section {
  padding: 80px 0;
  background: #f8fafc;
  
  .tips-text {
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
    margin-top: 20px;
  }
}

.gallery-bento {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 280px);
  gap: 20px;
  
  .gallery-item {
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #e2e8f0; // placeholder color
    box-shadow: 0 8px 24px rgba(0,0,0,0.06);
    cursor: pointer;
    
    .placeholder-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 40%);
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover {
      .placeholder-img {
        transform: scale(1.05);
      }
      &::after {
        opacity: 1;
      }
    }
  }

  // Layout Setup for 5 images
  // Item 1 spans 2 cols and 2 rows (Big Feature Image)
  .item-1 {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
  }
  // Items 2 & 3 take up top right
  .item-2 {
    grid-column: 3 / 4;
    grid-row: 1 / 2;
  }
  .item-3 {
    grid-column: 4 / 5;
    grid-row: 1 / 2;
  }
  // Items 4 & 5 take up bottom right
  .item-4 {
    grid-column: 3 / 4;
    grid-row: 2 / 3;
  }
  .item-5 {
    grid-column: 4 / 5;
    grid-row: 2 / 3;
  }
}

/* ==================================================
   4. Modern Timeline
   ================================================== */
.history-section {
  padding: 80px 0;
  background: #fff;
}

.modern-timeline {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 0;

  // Center vertical line
  .timeline-line {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    background: linear-gradient(to bottom, transparent, #0ea5e9 15%, #0ea5e9 85%, transparent);
    opacity: 0.3;
  }

  .timeline-node {
    position: relative;
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:last-child {
      margin-bottom: 0;
    }

    .pulse-dot {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #e0f2fe;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      box-shadow: 0 0 0 0 rgba(14, 165, 233, 0.4);
      animation: pulse 2s infinite;

      .inner-dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0ea5e9;
      }
    }

    .time-badge {
      width: 42%;
      position: relative;
      
      span {
        display: inline-block;
        background:linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
        color: white;
        padding: 6px 16px;
        border-radius: 30px;
        font-weight: 700;
        font-size: 14px;
        box-shadow: 0 4px 12px rgba(14, 165, 233, 0.25);
      }
    }

    .node-content {
      width: 42%;
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      border: 1px solid #e2e8f0;
      box-shadow: 0 10px 30px rgba(0,0,0,0.04);
      position: relative;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 40px rgba(10, 127, 215, 0.1);
        border-color: #bae6fd;
      }

      .event-desc {
        margin: 0;
        font-size: 15px;
        color: #475569;
        line-height: 1.6;
      }
      
      // Little arrow pointing to center
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border: 10px solid transparent;
      }
    }

    // Left oriented node (text on left, badge on right)
    &.node-left {
      flex-direction: row-reverse;
      
      .time-badge {
        text-align: left;
      }
      .node-content {
        text-align: right;
        &::before {
          right: -19px;
          border-left-color: #e2e8f0;
        }
        &::after { // Inner triangle to cover border
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -18px;
          border: 10px solid transparent;
          border-left-color: #fff;
        }
      }
    }

    // Right oriented node (text on right, badge on left)
    &.node-right {
      .time-badge {
        text-align: right;
      }
      .node-content {
        text-align: left;
        &::before {
          left: -19px;
          border-right-color: #e2e8f0;
        }
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -18px;
          border: 10px solid transparent;
          border-right-color: #fff;
        }
      }
    }
  }
}

// Keyframes
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(14, 165, 233, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(14, 165, 233, 0); }
  100% { box-shadow: 0 0 0 0 rgba(14, 165, 233, 0); }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ==================================================
   5. Join Us Call To Action
   ================================================== */
.join-us-section {
  padding: 80px 20px;
  background: white;
  text-align: center;

  .join-us-content {
    max-width: 800px;
    margin: 0 auto;
    background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
    padding: 60px 40px;
    border-radius: 24px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);

    h2 {
      font-size: 36px;
      font-weight: 800;
      color: #ffffff;
      margin-bottom: 16px;
      text-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }

    p {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.92);
      line-height: 1.6;
      margin-bottom: 32px;
    }

    .join-btn {
      background: #ffffff;
      color: #0a7fd7;
      border: none;
      padding: 16px 40px;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 15px rgba(10, 127, 215, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(10, 127, 215, 0.4);
      }
    }
  }
}

// Mobile Responsive
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }

  .section-title {
    font-size: 28px;
    margin-bottom: 12px;
  }

  .section-desc {
    font-size: 15px;
    margin-bottom: 36px;
  }

  .page-hero {
    height: 380px;

    .hero-content .hero-title {
      font-size: 34px;
      line-height: 1.25;
      overflow-wrap: anywhere;
      letter-spacing: -0.5px;
    }

    .hero-content .hero-subtitle {
      font-size: 17px;
      padding: 0 12px;
    }
  }

  .mission-vision-section {
    padding: 56px 0 32px;
  }

  .mv-grid {
    grid-template-columns: 1fr;
    gap: 20px;

    .mv-card {
      padding: 28px 20px;

      .card-icon {
        width: 56px;
        height: 56px;
        margin-bottom: 18px;

        i {
          font-size: 26px;
        }
      }

      h3 {
        font-size: 21px;
      }
    }
  }
  
  .gallery-bento {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    .item-1, .item-2, .item-3, .item-4, .item-5 {
      grid-column: 1 / 2;
      grid-row: auto;
      height: 250px; // Fixed height for mobile
    }
  }

  .history-section {
    padding: 56px 0;
  }

  .modern-timeline {
    .timeline-line {
      left: 24px;
    }

    .timeline-node {
      flex-direction: column !important;
      align-items: flex-start;
      padding-left: 60px;
      margin-bottom: 36px;

      .pulse-dot {
        left: 24px;
      }

      .time-badge {
        width: 100%;
        text-align: left !important;
        margin-bottom: 10px;

        span {
          font-size: 13px;
          padding: 5px 14px;
        }
      }

      .node-content {
        width: 100%;
        padding: 20px 16px;
        text-align: left !important;

        .event-desc {
          font-size: 14px;
        }
        
        &::before, &::after {
          display: none; // hide arrows on mobile
        }
      }
    }
  }

  .join-us-section {
    padding: 56px 16px;
  }

  .join-us-content {
    padding: 40px 24px;

    h2 {
      font-size: 28px;
    }

    p {
      font-size: 15px;
    }

    .join-btn {
      padding: 14px 32px;
      font-size: 15px;
    }
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 24px;
  }

  .page-hero {
    height: 320px;
    padding-top: 60px;

    .hero-content .hero-title {
      font-size: 28px;
    }

    .hero-content .hero-subtitle {
      font-size: 15px;
    }
  }

  .mv-card {
    border-radius: 16px;
  }

  .modern-timeline {
    .timeline-node {
      padding-left: 54px;
    }
  }

  .join-us-content {
    padding: 32px 20px;
    border-radius: 18px;
  }
}
</style>
